<div class="w-full max-w-7xl items-center">
  <section class="mb-8 flex lg:mb-0">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:min-w-[576px] md:p-10"
    >
      <!-- Comcast Business | Nitel Logo -->
      <div class="flex items-center justify-center">
        <a routerLink="/" class="inline-block" title="Go to homepage">
          <img
            [src]="
              siteUrl + '/assets/images/logos/comcast_bussiness_nitel_logo.png'
            "
            alt="Comcast Business | Nitel Logo"
            class="h-24 w-auto lg:h-28"
          />
        </a>
      </div>

      @if (isLoading() && !displayForm()) {
        <div class="mx-auto mt-4 flex justify-center">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }

      @if (displayForm()) {
        <!-- Title -->
        <h2
          class="mt-4 font-montserrat text-lg font-bold text-black lg:text-2xl"
        >
          Reset Your Password
        </h2>

        <form
          [formGroup]="resetPasswordFormGroup"
          novalidate
          (ngSubmit)="submitResetPassword()"
        >
          <span
            class="mt-4 flex font-lato text-[13px] font-bold tracking-[0.5px] text-black lg:text-sm"
          >
            Account
          </span>

          <div class="mb-4 flex font-lato text-base">
            {{ username() }}
          </div>

          <label for="password" class="comcast-input-label">New password</label>
          <input
            id="password"
            class="form-control"
            type="password"
            placeholder="Enter your new password"
            required
            name="password"
            (input)="validatePassword($event)"
            formControlName="pw1"
            class="comcast-input"
          />
          @if (!criteriaMet()) {
            <ul class="mt-2 flex flex-wrap font-lato text-sm">
              @for (c of criteria; track c) {
                <li
                  [ngClass]="{ 'opacity-50': !values[c].valid }"
                  class="flex basis-full list-none items-center lg:basis-1/2"
                >
                  @if (values[c].valid) {
                    <span class="material-icons text-[#1E8500]">done</span>
                  } @else {
                    <span class="material-icons text-[#D11314]"
                      >fiber_manual_record</span
                    >
                  }
                  <span>{{ values[c].label }}</span>
                </li>
              }
            </ul>
          } @else {
            <div class="comcast-validation-success">
              <span class="material-icons">check_circle_outline</span> Password
              meets all criteria.
            </div>
          }

          <label for="pw2" class="comcast-input-label mt-4"
            >Confirm new password</label
          >
          <input
            id="reenterPw"
            class="form-control"
            type="password"
            placeholder="Re-enter your new password"
            required
            name="pw2"
            (input)="doPasswordsMatch()"
            formControlName="pw2"
            [ngClass]="{
              'comcast-input-invalid': pwMatchErrorMessage.length > 0,
            }"
            class="comcast-input"
          />
          @if (pwMatchErrorMessage().length > 0) {
            <div class="comcast-validation-error">
              {{ pwMatchErrorMessage() }}
            </div>
          }
          @if (pwMatchSuccessMessage().length > 0) {
            <div class="comcast-validation-success">
              <span class="material-icons">check_circle_outline</span>
              {{ pwMatchSuccessMessage() }}
            </div>
          }

          @if (errorMessage() && !isLoading()) {
            <div class="comcast-validation-error">
              {{ errorMessage() }}
            </div>
          }

          <div class="mt-6 flex">
            <button
              type="submit"
              [disabled]="!criteriaMet() || isLoading()"
              class="btn-primary"
            >
              @if (isLoading()) {
                <div class="flex min-w-12 justify-center">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              } @else {
                Reset Password
              }
            </button>
          </div>
        </form>
      } @else {
        <div class="mt-4 flex font-lato text-base lg:text-lg">
          This link has expired. Click the button below to reset your password.
        </div>

        <div class="mt-6 flex">
          <a
            routerLink="/forgot-password"
            title="Go to Forgot Password"
            class="btn-primary"
            >Go to Forgot Password
          </a>
        </div>
      }
    </div>
  </section>
</div>
